import {
    apiRequest,
    configTunjanganList,
    configTunjanganActive,
    configTunjanganInactive
} from "../../../../../services/adapters/kepegawaian/configTunjanganService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", configTunjanganList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", configTunjanganInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", configTunjanganActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository